import React, { useRef } from "react";
import { Phone, Mail, BadgeCheck, Download } from "lucide-react";
import { Logo } from "@/components/Logo";

export function VisitingCard({ user, photo }) {
  const name = user?.name || "Adviser";
  const code = user?.user_code || "—";
  const mobile = user?.mobile ? `+91 ${user.mobile}` : "—";
  const email = user?.email || "—";
  return (
    <div data-testid="visiting-card" className="w-full max-w-[520px] rounded-2xl overflow-hidden shadow-2xl shadow-slate-900/20 border border-white/10 flex">
      {/* Company side */}
      <div className="w-[42%] bg-[#0B223D] p-6 flex flex-col items-center justify-center text-center">
        <Logo height={40} light />
        <p className="text-teal-400 text-[10px] font-bold uppercase tracking-widest mt-3">Refer · Apply · Earn</p>
        <div className="mt-4 text-white/60 text-[10px] leading-relaxed">
          India's direct Refer &amp; Earn fintech marketplace
        </div>
      </div>
      {/* Agent side */}
      <div className="w-[58%] bg-white p-6 flex flex-col">
        <div className="flex items-center gap-3">
          {photo ? (
            <img src={photo} alt={name} className="w-16 h-16 rounded-full object-cover border-2 border-teal-500" data-testid="visiting-card-photo" />
          ) : (
            <div className="w-16 h-16 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center font-display font-extrabold text-2xl border-2 border-teal-200">
              {name.charAt(0).toUpperCase()}
            </div>
          )}
          <div>
            <h3 className="font-display font-extrabold text-lg text-[#0B223D] leading-tight">{name}</h3>
            <span className="inline-flex items-center gap-1 bg-teal-50 text-teal-700 text-[11px] font-bold px-2 py-0.5 rounded-full mt-1">
              <BadgeCheck className="w-3 h-3" /> Adviser
            </span>
          </div>
        </div>
        <div className="mt-4 space-y-1.5 text-sm">
          <p className="font-mono-num text-xs text-slate-400">ID: {code}</p>
          <a href={`tel:${mobile}`} className="flex items-center gap-2 text-slate-600"><Phone className="w-3.5 h-3.5 text-teal-600" /> {mobile}</a>
          <a href={`mailto:${email}`} className="flex items-center gap-2 text-slate-600 break-all"><Mail className="w-3.5 h-3.5 text-teal-600" /> {email}</a>
        </div>
        <p className="mt-auto pt-3 text-[9px] text-slate-400 leading-snug border-t border-slate-100">
          Independent freelance Adviser. This is a freelancing referral ID — not an employee of Credit Kendra. No employment relationship is implied or claimed.
        </p>
      </div>
    </div>
  );
}
